import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { usePrevious } from '@zola/zola-ui/src/hooks/usePrevious';

import InputFieldV3 from '@zola/zola-ui/src/components/Form/inputV3/InputFieldV3';

import { useWebsiteThemeContext } from 'components/publicWebsiteV2/context';
import { mapFontColorToBgOverlayWithOpacity } from 'components/publicWebsiteV2/util/mappers';
import { useAppDispatch } from 'reducers/index';
import { submitPasscode } from 'actions/PublicWebsiteActions';

import { Form, Instructions, InputContainer } from './Passcode.styles';

const PasscodeForm = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [passcode, setPasscode] = useState('');
  const prevValue = usePrevious(passcode);
  const [errorMsg, setErrorMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const {
    state: {
      components: { cmsEntityComponentBodyFontValues, cmsEntityComponentBodyFontStyles, Button },
      wedding,
    },
  } = useWebsiteThemeContext();
  const {
    query: { returnTo },
  } = router;

  const { passcode_instructions, slug } = wedding || {};

  const handleInputField = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    setPasscode(value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!passcode) {
      setErrorMsg('Required');
    } else {
      dispatch(submitPasscode({ slug, passcode }))
        .then(() => {
          window.location.assign(`/wedding/${slug as string}${returnTo ? `/${returnTo}` : ''}`);
        })
        .catch(() => {
          setErrorMsg('Invalid password');
        });
    }
  };

  const handleTogglePasswordVisibility = () => setShowPassword(!showPassword);

  useEffect(() => {
    /* Clear error message when user starts typing something new */
    if (errorMsg && passcode !== prevValue) setErrorMsg('');
  }, [passcode, prevValue, errorMsg]);

  return (
    <Form
      onSubmit={handleSubmit}
      bgColor={mapFontColorToBgOverlayWithOpacity(cmsEntityComponentBodyFontValues.color)}
    >
      <Instructions css={cmsEntityComponentBodyFontStyles}>{passcode_instructions}</Instructions>
      <InputContainer>
        <InputFieldV3
          id="public-v2-passcode"
          onChange={handleInputField}
          placeholder="Password"
          value={passcode}
          isControlled
          errorMessage={errorMsg}
          type={showPassword ? 'text' : 'password'}
          onTogglePasswordVisibility={handleTogglePasswordVisibility}
          password
        />
      </InputContainer>
      <Button type="submit">Submit</Button>
    </Form>
  );
};

export default PasscodeForm;
